/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, GetYoutubeIntegrationBroadcastsBroadcastsPathParams, GetYoutubeIntegrationBroadcastsBroadcastsQueryParams } from "../models/GetYoutubeIntegrationBroadcastsBroadcasts";

export function getGetYoutubeIntegrationBroadcastsBroadcastsUrl(station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"]) {
  const res = { method: 'GET', url: `/youtube-broadcasts/${station}` as const }
  return res
}

/**
 * @description Computes on-air intervals from stream gaps in the requested window and enriches them with live/ended YouTube video metadata for the station channel.
 * @summary List on-air broadcasts for a station
 * {@link /youtube-broadcasts/:station}
 */
export async function getYoutubeIntegrationBroadcastsBroadcasts(station: GetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: GetYoutubeIntegrationBroadcastsBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubeIntegrationBroadcastsBroadcastsUrl(station).url.toString(), params, ... requestConfig })
  return res.data
}